export const getPaymentMethodsFromRetailer = store => {
  if (store.paymentMethods) {
    return store.paymentMethods
  } else if (store.retailer.paymentMethods) {
    return store.retailer.paymentMethods
  } else {
    return []
  }
}
